import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const VideoWidgetStaticSchema = BaseWidgetSchema(WidgetType.Video).extend({
  src: z.string(),
  title: z.string()
});

export type VideoWidgetStaticSchemaType = z.infer<typeof VideoWidgetStaticSchema>;
